import { Length } from "@siteimprove/alfa-css";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/outline-offset}
 */
export default Longhand.of(Length.of(0, "px"), Length.parse, (value, style) => value.resolve(Resolver.length(style)));
//# sourceMappingURL=outline-offset.js.map